import { defineComponent, h, PropType, watch } from 'vue';
import { coming_soon } from '@components/icons';
import { stitch } from '../../set-button-state';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { withSpinner } from '../../state/spinner';
import mergeonedge_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/merge_on_edge.svg';
import { img } from '@phi/components';
import MergeOnEdgeTooltip from './MergeOnEdgeTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const StitchIcon = mergeonedge_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    data() {
        return {
            callback: undefined as ReturnType<typeof stitch>,
        };
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Stitch';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || !this.callback;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    mounted() {
        watch(
            () => this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count,
            () => {
                this.callback = stitch();
            }
        );
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            if (this.callback)
                withSpinner('Stitching', this.callback)();
        }
    },

    render() {
        return h(BarButton, {
            id: 'stitch-button',
            tippy: 'bottom',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 4,
            help: 'merge_on_edge',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(mergeonedge_svg, this.alt),
            tooltip: MergeOnEdgeTooltip,
        });
    },
});
